import { render, staticRenderFns } from "./VolumeIntensityChart.vue?vue&type=template&id=b012834e"
import script from "./VolumeIntensityChart.vue?vue&type=script&lang=js"
export * from "./VolumeIntensityChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports